import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {
  UserPreferencesApiModule,
  UserPreferencesConfiguration,
} from '@compumark/user-preferences-backend-specifications';

import { environment } from '../../environments/environment';
import { ChipsModule } from '../chips/chips.module';

import { EmailAlertsDialogComponent } from './email-alerts-dialog/email-alerts-dialog.component';
import { EmailAlertsComponent } from './email-alerts/email-alerts.component';

export function userPreferenceModuleConfigurationFactory(): UserPreferencesConfiguration {
  return new UserPreferencesConfiguration({
    basePath: environment.backendBaseUrl,
    withCredentials: true,
  });
}

@NgModule({
  declarations: [EmailAlertsComponent, EmailAlertsDialogComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    UserPreferencesApiModule.forRoot(userPreferenceModuleConfigurationFactory),
    HttpClientModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    ChipsModule,
  ],
  exports: [EmailAlertsComponent],
})
export class PreferencesModule {}
